module.exports = __webpack_public_path__ + "img/搜索.f0fa2b38.png";